const url = '/settings';
const Provider = 'Settings';
const dbModel = 'Settings';

export { url, Provider, dbModel };
